import { message, notification } from "antd";
import {
  APIResponseStatus,
  ServiceProviderActions,
} from "../Constants/Constants";
import { convertProviderFormToApiValues } from "../Helpers/ServiceProviderHelpers";
import { apiCallback } from "./Common";

const getMessage = (action, success) => {
  if (success) {
    return `Service Provider ${
      action === ServiceProviderActions.add ? "added" : "updated"
    } successfully!`;
  }
  return `Error ${
    action === ServiceProviderActions.add ? "adding" : "updating"
  } Service Provider`;
};

export const onFormSubmit =
  ({ props, setProcessing, setInitialValues }) =>
  (values) => {
    const { action, record, serviceProviderApi } = props;
    console.log("form onSubmit", values, props);
    const failMessage = getMessage(action, false);
    const successMsg = getMessage(action, true);

    const errorCallback = (error) => {
      setProcessing(false);
      console.error("Service Provider form submit error!", error);
      message.error(failMessage);
    };
    const failCallback = (data) => {
      if (data.info === "ExistingServiceProvider") {
        setProcessing(false);
        notification["error"]({
          message: `Error creating Service Provider`,
          description: `Service Provider name already exist.`,
        });
      } else {
        errorCallback();
      }
    };
    const successCallback = (data) => {
      setInitialValues(values);
      message.success(successMsg);
      props.onSubmit({ redirect: action === ServiceProviderActions.add });
    };
    const callback = apiCallback({
      history: props.history,
      preProcess: () => setProcessing(false),
      failCallback,
      errorCallback,
      successCallback,
    });

    try {
      setProcessing(true);
      values.id = record?.providerId;
      const formattedData = convertProviderFormToApiValues(values, action);
      console.log("onSubmit formattedData", formattedData);
      if (action === ServiceProviderActions.add) {
        serviceProviderApi.addServiceprovider(formattedData, callback);
      } else {
        serviceProviderApi.updateServiceprovider(formattedData, callback);
      }
    } catch (error) {
      errorCallback(error);
    }
  };
